// extracted by mini-css-extract-plugin
export default {"Switch":"Slider__Switch__fD73P","Slider":"Slider__Slider__bnwWr"};